export const uses = [
  {
    name: 'every day carry',
    description:
      'These are the things that I have with me if I am going outside. Obviously not going out that often these days due to the COVID-19 pandemic.',
    sort: true,
    itemList: [
      {
        name: 'Breadband Wallet',
        attributeList: [
          {
            name: 'Tile Slim (2020)',
          },
          {
            name: 'Check out other wallets that I like',
            url: 'https://youtu.be/LNc06yF3IAQ',
          },
          {
            name: 'See all the credit cards that I use',
            url: 'https://youtu.be/ttq1PKB5RDk',
          },
        ],
      },
      {
        name: 'Powecom KN95 Respirator Face Mask',
        url: 'https://bonafidemasks.com/Powecom-kn-95/',
        attributeList: [
          {
            name: 'I pair it with these Ursa Maskies for all-day comfort',
            url: 'https://smile.amazon.com/gp/product/B08NXG8DD8?psc=1',
          },
          {
            name: 'Previously used the Hedley & Bennett Wake Up and Fight Mask',
            url: 'https://youtu.be/Yc53Yg2xY6Y',
          },
        ],
      },
      { name: 'Galaxy Buds Pro' },
      {
        name: 'Mission Workshop The Rummy Messenger Bag',
        attributeList: [
          {
            name: "The most expensive messenger bag I have bought but it's totally worth it.",
          },
          {
            name: "Extremely durable and it's weather proof.",
          },
        ],
      },
      {
        name: 'Samsung Galaxy S22 Ultra',
        attributeList: [
          {
            name: 'Check out my first impressions video',
            url: 'https://youtu.be/hxbOaLf4sRA',
          },
        ],
      },
      {
        name: 'Samsung Galaxy Watch4',
        attributeList: [
          { name: '44mm Silver' },
          {
            name: 'DaQin Stretchy Nylon Band (Plum)',
            url: 'https://amazon.com/gp/product/B09JW6W84L',
          },
          {
            name: 'Watch my full review of this smartwatch',
            url: 'https://youtu.be/ZN9mA3_JG7E',
          },
        ],
      },
      {
        name: 'Zojirushi 600ml Stainless Steel Mug',
        url: 'https://www.amazon.com/gp/product/B00HYOGUM2?psc=1',
        attributeList: [
          { name: "The best water bottle I've used. Keeps cold water cold and hot water hot." },
        ],
      },
      { name: 'Galaxy SmartTag+' },
      {
        name: 'Roav Sunglasses',
        url: 'https://roaveyewear.com/collections/origin-series/products/freddy-black-moonrise',
        attributeList: [
          { name: 'Freddy frame/shape in Black/Sunrise colorway.' },
          { name: 'These are durable, lightweight and folds into my pocket.' },
        ],
      },
    ],
  },
  {
    name: 'hardware',
    description:
      'Since I spend a lot of time creating content, I have invested in quite a bit of gear to help streamline my workflow.',
    categoryList: [
      {
        name: 'desk setup',
        list: [
          {
            name: 'MacBook Pro 16-inch (Late 2019)',
            attributeList: [
              { name: '2.4GHz 8-core Intel Core i9' },
              { name: '32GB 2667MHz DDR4' },
              { name: 'AMD Radeon Pro 5500M with 8GB GDDR6 memory' },
              { name: '2TB SSD' },
              {
                name: 'dbrand Black Camo Skin',
                url: 'https://dbrand.com/shop/apple-macbook-pro-16-skins-2019',
              },
            ],
          },
          {
            name: 'iPad Pro 11-inch (2nd generation)',
            attributeList: [
              { name: 'Apple Pencil 2' },
              {
                name: 'Zugu Case The Alpha Case',
                url: 'https://www.zugucase.com/the-alpha-case-2020-ipad-pro-11-2nd-gen-new-model/',
              },
              {
                name: 'I use this primarily for note taking and visualizing programming problems.',
              },
            ],
          },
          {
            name: 'Uplift V2 Standing Desk',
            attributeList: [
              { name: '72"x30" Whiteboard Laminate' },
              { name: 'V2 C-Frame - Black' },
              { name: 'Advanced Comfort Keypad - Black' },
            ],
          },
          { name: 'Herman Miller Aeron' },
          { name: 'Elgato Wave Panels' },
          {
            name: 'Dell U2720Q 27-inch Monitor',
            attributeList: [
              {
                name: 'Upgraded from my trusty Dell U2415.',
                url: 'https://twitter.com/dickwyn/status/1433207786528075781',
              },
              {
                name: 'I got this so that I can natively master/edit my YouTube videos on this 10-bit 4K panel.',
              },
            ],
          },
          {
            name: 'BenQ ScreenBar Plus',
            url: 'https://www.benq.com/en-us/lamps/computer-desklamp/screenbar-plus.html',
          },
          {
            name: 'Amazon Basics Single Monitor Stand',
            attributeList: [
              { name: 'Paired with an Amazon Basics Notebook Laptop Stand Arm Mount Tray.' },
              { name: 'I use this to prop up my laptop.' },
            ],
          },
          {
            name: 'PreSonus Eris E3.5 studio monitors',
            attributeList: [
              { name: 'I have these sitting on top of sound isolation pads from Sound Addicted.' },
            ],
          },
          { name: 'Logitech MX Anywhere 3' },
          {
            name: 'Happy Hacking Keyboard (HHKB) Professional HYBRID Type-S',
            url: 'https://happyhackingkb.com/',
            attributeList: [
              {
                name: 'KBDFans Blank White and Gray PBT Keycaps',
                url: 'https://mechanicalkeyboards.com/shop/index.php?l=product_detail&p=6809',
              },
              {
                name: 'Check out my full review of this keyboard',
                url: 'https://youtu.be/jG-0pFJ1oNE',
              },
            ],
          },
          {
            name: 'Stack Overflow The Key Macropad',
            url: 'https://drop.com/buy/stack-overflow-the-key-macropad',
          },
          { name: 'DaVinci Resolve Speed Editor' },
          {
            name: 'Samsung Wireless Charger Pad 9W',
            attributeList: [{ name: 'Charges both my smartwatch and smartphone.' }],
          },
          { name: 'Tripp Lite 10 Outlet Surge Protector' },
          { name: 'Anker 40W 5-port USB Wall Charger' },
        ],
      },
      {
        name: 'youtube setup',
        list: [
          {
            name: 'Sony a7 IV (A-Camera)',
            attributeList: [
              { name: 'Sigma 24-70mm f/2.8 DG DN (Sony E)' },
              { name: '256GB ProGrade Digital V60 SD Card' },
            ],
          },
          {
            name: 'Panasonic Lumix G9 (B-Camera)',
            attributeList: [
              { name: 'Sigma 18-35mm f/1.8 DC (Canon EF)' },
              { name: 'Viltrox EF-M2 II' },
              { name: 'SmallRig Lens Adapter Support' },
              { name: '128GB SanDisk Extreme PRO SD Card' },
              { name: 'SmallRig Cage (2125)' },
              { name: 'Portkeys P6' },
            ],
          },
          {
            name: 'Panasonic Lumix GH4 (C-Camera)',
            attributeList: [
              { name: 'Olympus 12-40mm f/2.8 PRO' },
              { name: '128GB SanDisk Extreme PRO SD Card' },
              { name: 'Manfrotto 200PL Quick Release Plate' },
            ],
          },
          {
            name: 'Sound Devices MixPre-3 II',
            attributeList: [
              { name: '64GB SanDisk Extreme SD Card' },
              { name: 'Rode NTG5' },
              { name: 'Sony MDR-7506' },
              { name: 'Ikea Ladda AA 2450mAh' },
            ],
          },
          {
            name: 'Sachtler Ace M System Black Edition with Tripod & Mid-Level Spreader',
          },
          {
            name: 'Manfrotto Element Traveller Tripod',
            attributeList: [
              { name: 'Manfrotto XPRO Fluid Head' },
              { name: 'Tri-Wheel Leveling Base with Bubble Level' },
            ],
          },
          {
            name: 'Desview T2 Teleprompter',
            attributeList: [
              {
                name: 'My secret to speaking naturally in front of the camera.',
                url: 'https://youtu.be/KqPJ82diq-g',
              },
            ],
          },
          {
            name: 'Godox VL150 LED Video Light',
            attributeList: [
              { name: 'Glow EZ Lock Deep Parabolic Quick Softbox (28")' },
              { name: 'I use this as my main key light.' },
            ],
          },
          {
            name: 'Aputure MC RGBWW LED Light',
          },
          {
            name: 'Aputure Accent B7c LED RGBWW Light',
          },
          {
            name: 'GVM 480LS Bi-color LED Light',
          },
          { name: 'Elvid 9-Section Acrylic Production Slate with Color Clapper Sticks' },
          { name: 'X-Rite ColorChecker Passport Video' },
          {
            name: 'Sure-Max Pro Economy Moving Blanket',
            attributeList: [{ name: 'I use this for sound treating a room.' }],
          },
        ],
      },
      {
        name: 'storage',
        sort: true,
        list: [
          {
            name: '2TB Samsung T5 SSD',
            attributeList: [{ name: "This drive mirrors the files on my MacBook Pro's SSD." }],
          },
          { name: '500GB Samsung T5 SSD' },
          { name: '5TB Western Digital My Passport Ultra' },
        ],
      },
      {
        name: 'camera',
        sort: true,
        list: [{ name: 'Canon AE-1 Program' }],
      },
      {
        name: 'lenses',
        sort: true,
        list: [
          { name: 'Canon 50mm f/1.4 FD' },
          { name: 'Helios 44-2 58mm f/2.0' },
          { name: 'Panasonic 7-14mm f/4.0' },
          { name: 'Sony 90mm f/2.8 Macro' },
        ],
      },
      {
        name: 'audio',
        sort: true,
        list: [
          { name: 'Rode VideoMicro' },
          { name: 'Tascam DR-10L' },
          { name: 'Tentacle Sync Track E' },
          { name: 'Rode VideoMic NTG' },
          { name: 'Deity W.Lav Pro' },
          { name: 'Bubblebee Industries Lav Concealer' },
        ],
      },
      {
        name: 'camera accessories',
        sort: true,
        list: [
          { name: 'Giottos Rocket Air Blaster' },
          { name: 'Peak Design Slide Lite' },
          { name: 'Pelican SD Memory Card Case' },
          { name: 'Neewer 43-inch Light Reflector 5-in-1' },
          { name: 'Peak Design Camera Cube' },
          { name: 'Eneloop AA Rechargeable Battery' },
          { name: 'Amazon Basics AAA Rechargeable Battery' },
          { name: 'Rycote Undercover with Stickies' },
          { name: 'Bongo Ties' },
          { name: 'Robo-Grip Pliers' },
          { name: 'Spring 1/4" Glow-in-The-Dark', url: 'https://www.getsprig.co' },
          { name: 'Pancro Professional Lens Cleaner' },
          { name: 'Kimtech Kimwipes Delicate Task Wipers' },
          { name: 'Tentacle Sync E Timecode Generator' },
        ],
      },
    ],
  },
  {
    name: 'software',
    description:
      "You can't really have hardware without software. Here's a list of programs that I have installed on my devices.",
    categoryList: [
      {
        name: 'common',
        sort: true,
        list: [
          { name: 'Affinity Photo' },
          { name: 'Davinci Resolve Studio' },
          { name: 'Figma' },
          { name: 'Google Chrome' },
          { name: 'Malwarebytes' },
          { name: 'Microsoft Office' },
          { name: 'Spotify' },
          { name: 'Visual Studio Code' },
          { name: 'WhatsApp' },
          { name: 'Logi Options+' },
          { name: 'Microsoft To Do' },
          { name: 'Microsoft Edge' },
          { name: 'FreeFileSync' },
          { name: 'f.lux' },
          { name: 'iZotope RX 8' },
          { name: '1Password 8' },
        ],
      },
      {
        name: 'mac',
        sort: true,
        list: [
          { name: 'Alfred 4' },
          { name: 'iTerm' },
          { name: 'MacTeX' },
          { name: 'Magnet' },
          { name: 'iStat Menus' },
          { name: 'AppCleaner' },
          { name: 'Pixelmator Pro' },
          { name: 'DevSwatch' },
          { name: 'IINA' },
          { name: 'Hidden Bar' },
          { name: 'Karabiner-Elements' },
          { name: 'Muzzle' },
        ],
      },
      {
        name: 'windows',
        sort: true,
        list: [{ name: 'MiKTeX' }, { name: 'PhotoScape' }, { name: 'Windows Terminal' }],
      },
      {
        name: 'android',
        list: [
          {
            name: "Check out my What's on my Android phone video",
            url: 'https://youtu.be/iLKrwYxdtb0',
          },
        ],
      },
      {
        name: 'chrome extensions',
        sort: true,
        list: [
          { name: '1Password X Beta' },
          { name: 'GoFullPage - Full Page Screen Capture' },
          { name: 'Grammarly' },
          { name: 'META SEO inspector' },
          { name: 'React Developer Tools' },
          { name: 'uBlock Origin' },
          { name: 'vidIQ Vision for YouTube' },
          { name: 'Wappalyzer' },
          { name: 'WAVE Evaluation Tool' },
          { name: 'Decentraleyes' },
          { name: 'Disconnect' },
          { name: 'The Camelizer' },
          { name: 'ClearURLs' },
          { name: 'Honey' },
          { name: 'Return YouTube Dislike' },
          { name: 'SponsorBlock for YouTube' },
          { name: 'Webtime Tracker' },
        ],
      },
      {
        name: 'visual studio code extensions',
        sort: true,
        list: [
          { name: 'Better Comments' },
          { name: 'Code Spell Checker' },
          { name: 'GitLens' },
          { name: 'LaTeX Workshop' },
          { name: 'Live Server' },
          { name: 'Material Icon Theme' },
          { name: 'Peacock' },
          { name: 'Prettier' },
          { name: 'Rainglow' },
          { name: 'Todo Tree' },
          { name: 'Quokka.js' },
        ],
      },
    ],
  },
];
